const searchPage = document.getElementById('search'); //getting from body tag

if (searchPage) {
  const searchClient = algoliasearch('NWGV27CU6A', 'ee8778c8ed1a68b31aae66d2b5a85bab');

  const search = instantsearch({
    indexName: 'shopify_products',
    searchClient,
  });

  search.addWidgets([
    instantsearch.widgets.configure({
      filters: 'tags:discoverable',
    }),
    instantsearch.widgets.searchBox({
      container: '#searchbox',
    }),
    instantsearch.widgets.hits({
      container: '#hits',
      transformItems(items) {
        // Filter items BEFORE rendering to prevent CLS
        return items.filter((hit) => {
          const hasValidPrice = parseInt(hit.price) > 0;
          if (!hasValidPrice) return false;
          if (typeof algoliaDisplayedProducts !== 'undefined' && algoliaDisplayedProducts) {
            return algoliaDisplayedProducts.includes(hit.handle);
          }
          return true;
        });
      },
      templates: {
        item(hit) {
          let category;
          let description;
          
          if (
            typeof productsCategoryByHandle !== 'undefined' &&
            productsCategoryByHandle &&
            productsCategoryByHandle[hit.handle]
          ) {
            category = productsCategoryByHandle[hit.handle].category;
            description = productsCategoryByHandle[hit.handle].description;
          }
          
          const price = parseInt(hit.price) % 1 == 0 ? parseInt(hit.price).toFixed(2) : hit.price;
          return `
            <div class="product-card-container js-hp-shop-products">
              <a class="products-grid-item__wrapper" href="/products/${hit.handle}" tabindex="-1">
                <img aria-hidden="true" class="product-new__collection__photo right" loading="lazy" alt="${hit.handle}" src="${hit.image}">
                ${category ? `<div class="category">${category}</div>` : ''}
                <div class="title">${hit.title}</div>
                <div class="description">${description}</div>
              </a>
              <div class="price">$${price}</div>
            </div>
          `;
        },
      },
    }),
  ]);

  search.start();

  // Show search page after first render to prevent CLS
  search.on('render', () => {
    const productsContainer = searchPage.querySelector('.products-container');
    if (productsContainer && productsContainer.style.visibility === 'hidden') {
      productsContainer.style.visibility = 'visible';
    }
  });

  const handlePredefinedSearch = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchValue = urlParams.get('value');
    if (searchValue) {
      const searchBox = document.querySelector('.ais-SearchBox-input');
      if (searchBox) {
        searchBox.value = searchValue;
        search.helper.setQuery(searchValue).search();
      }
    }
  };

  if (document.readyState !== 'loading') {
    handlePredefinedSearch();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      handlePredefinedSearch();
    });
  }
}
